import { Injectable, Output, EventEmitter } from "@angular/core";
import * as pbi from '../public/index.component'
declare var jquery: any;
declare var $: any;
@Injectable()
export class AdminService {
  pb_func: pbi.PublicComponent = new pbi.PublicComponent();
  loading = true;
  backLoad = "rgb(255 255 255 / 33%)";
  FullName = "";
  eMail = "";
  Phone = "";
  More = "";
  Avatar = this.pb_func.NotImage;
  @Output() change: EventEmitter<any> = new EventEmitter();
  @Output() changeUser: EventEmitter<any> = new EventEmitter();
  @Output() changeLinkMN: EventEmitter<any> = new EventEmitter();

  openLoading0() {
    this.change.emit({ status: true, backLoad: "#352e2e87" });
  }

  openLoading1() {
    this.change.emit({ status: true, backLoad: "#352e2e87" });
  }

  closeLoading(callback) {
    $(window).resize();
    setTimeout(() => {
      this.change.emit({ status: false, backLoad: "#352e2e87" });
      callback(1);
    }, 200);
  }

  setUserInfo(FullName: string, eMail: string, Phone: string, More: string, Avatar: string) {
    this.FullName = FullName;
    this.eMail = eMail;
    this.Phone = Phone;
    this.More = More;

    if (Avatar != null && Avatar != "") {
      this.Avatar = Avatar + "?" + this.pb_func.NewId();
    }
    else {
      this.Avatar = this.pb_func.NotImage;
    }

    this.changeUser.emit({
      FullName: this.FullName,
      eMail: this.eMail,
      Phone: this.Phone,
      More: this.More,
      Avatar: this.Avatar
    });
  }

  getUserInfo(callback) {
    callback({
      FullName: this.FullName,
      eMail: this.eMail,
      Phone: this.Phone,
      More: this.More,
      Avatar: this.Avatar
    });
  }

  getLinkMeNu(url:string){
    this.changeLinkMN.emit({ url: url });
  }
}


// WEBPACK FOOTER //
// ./src/app/admin/admin.service.ts